import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";


export default css`
  .filterContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: auto;
    min-height: 36px;
    width: 100%;
    padding:6px;
    cursor: pointer;
  }
  
  .filterBox {
    overflow: hidden;
    transition: max-height 0.4s ease-in;  
    background-color: ${getColor(COLOR_DICTIONARY.GREY_100)};
    padding-top:6px;
    border-radius: 5px;
  }

  :global(.more) {
    transition: max-height 0.3s ease-out;  
  }

  .filterMore {
    padding-left:6px;
    width:100%;
    height:35px;
    display:flex;
    align-items:center;
  }



  .filterContainer:hover {
    background: #019df426;
    border-radius: 5px;
  }

  :global(.filterContainer .checkbox) {
    padding-left: 25px;
    padding-bottom: 8px;
  }
`;
